import { DestroyRef, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ModalLinkService } from '@core/feature';
import { SdModalService } from '@sdvor/shared/ui/v2';
import { EmailSubscriptionModalComponent } from './email-subscription-modal.component';

@Injectable({ providedIn: 'root' })
export class PromoModalLinkListenerService {
  private readonly modalLinkService = inject(ModalLinkService);
  private readonly modalService = inject(SdModalService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly subscribeEmailModalName = 'EmailSubscriptionModalComponent';

  constructor() {
    this.modalLinkService.openedModalName.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((modalName) => {
      if (modalName !== this.subscribeEmailModalName) {
        return;
      }

      this.modalService.open(EmailSubscriptionModalComponent, {
        modalType: { xxs: 'compact', md: 'compact', lg: 'standard' },
        maxWidth: { xxs: '343px', md: '423px', lg: '464px' },
      });
    });
  }
}
